import { useContext } from "react";
import { SeshTextChannelData } from "../../../../../../../common/sesh_types";
import { ChannelSelectForm } from "../../../../forms/channel_dropdown";
import { GuildSettingsContext } from "../../../guild_settings";

export enum RequiredPermission {
	Read,
	Write,
}

export default function GuildSettingsChannelPicker(props: {
	channel: string | null;
	set_channel: (included_channel: string | null) => void;
	requiredPermission: RequiredPermission;
	name?: string | JSX.Element;
	description?: string;
	hasUnsavedChanges?: boolean;
}) {
	const { all_text_channels, original_guild_settings, is_admin } =
		useContext(GuildSettingsContext);

	const {
		event_channel,
		event_channel_override_only_admins,
		event_channel_require_send_messages,
	} = original_guild_settings;

	let filteredChannels: SeshTextChannelData[];

	switch (props.requiredPermission) {
		case RequiredPermission.Read: {
			// all_text_channels is already filtered to channels with read permissions
			filteredChannels = all_text_channels;
			break;
		}

		case RequiredPermission.Write: {
			filteredChannels = all_text_channels.filter((channel) => {
				if (
					event_channel &&
					event_channel_override_only_admins &&
					!is_admin
				) {
					return (
						channel.id === event_channel.id &&
						(!event_channel_require_send_messages ||
							event_channel.has_write)
					);
				}

				return channel.has_write;
			});
			break;
		}
	}

	if (filteredChannels.length === 0) {
		return (
			<p className="error-text">
				Error: Couldn't find channels. Check that you have Read messages
				or Send messages permissions.
			</p>
		);
	}

	return (
		<ChannelSelectForm
			name={props.name}
			info={props.description}
			initial_value={
				props.channel
					? filteredChannels.find((channel) => {
							return channel.id === props.channel;
					  })
					: event_channel
					? filteredChannels.find((channel) => {
							return channel.id === event_channel.id;
					  })
					: null
			}
			update_initially={true}
			channel_data={filteredChannels}
			disabled={false}
			updateFunc={(val) => {
				props.set_channel(val.id);
			}}
			include_threads={false}
			has_unsaved_changes={props.hasUnsavedChanges}
		/>
	);
}
